import css from 'styled-jsx/css';

const staticStyles = css`
  .CreateWalletForm {
  }
`;

export default staticStyles;
